import type { AnyAction } from 'redux';

import { actions } from 'app/redux/actions/entities';
import type { User } from 'app/typings';

export type Auth = {
  user?: User;
  token?: string;
};

const initialState: Auth = {};

export function auth(state = initialState, action: AnyAction) {
  switch (action.type) {
    case actions.USER_LOGGED_IN:
      return { user: action.user, token: action.token };
    default:
      return state;
  }
}
